import { render, staticRenderFns } from "./BillingDocumentNewStatement.vue?vue&type=template&id=92a498e6&scoped=true&"
import script from "./BillingDocumentNewStatement.vue?vue&type=script&lang=js&"
export * from "./BillingDocumentNewStatement.vue?vue&type=script&lang=js&"
import style0 from "./BillingDocumentNewStatement.vue?vue&type=style&index=0&id=92a498e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a498e6",
  null
  
)

export default component.exports